import { API_ROUTES } from '@/constants/api-routes';
import { API_URL_V3 } from '@/constants/constants';
import { QUERY_KEYS } from '@/constants/query-keys';
import { generateAuthHeaders } from '@/utils/generate-auth-headers';
import axios from 'axios';
import { useMutation } from 'react-query';

export interface StripeConnectionResponse {
  monday_account_id: number;
  stripe_account_id: string;
  onboarding_link: string | null;
}

const useConnectStripe = ({ options }) => {
  return useMutation<StripeConnectionResponse>(
    async () => {
      const { data } = await axios({
        baseURL: API_URL_V3,
        url: API_ROUTES.CONNECT_STRIPE,
        method: 'POST',
        headers: generateAuthHeaders(),
      });

      return data;
    },
    {
      mutationKey: QUERY_KEYS.CONNECT_STRIPE,
      ...options,
    },
  );
};

export default useConnectStripe;
